import axios, { AxiosRequestConfig } from 'axios';
// eslint-disable-next-line import/no-extraneous-dependencies
import qs from 'qs';
import type { Dayjs } from 'dayjs';

import { AxiosServiceResponse, PagedList } from 'interfaces/general';

import { UserItem } from './security';
import { ITicketProblemResponse, SaveTicketRequest } from './ticket';

const instance = axios.create({
  baseURL: `${process.env.PROCESS_SERVICE_ENDPOINT}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

export interface ItemCABResponse {
  id: number;
  name: string;
  description: string;
  members: UserItem[];
}
export interface IApproveChangeRequest {
  approvalId: number;
  isApproved: boolean;
  comment: string;
}

export interface ISendApprovalNotification {
  changeStepId: number;
  approvalIds: number[];
  emailSubject: string;
  emailBody: string;
}

export interface IAddApprovalMembers {
  changeStepId: number;
  systemUserIds: number[];
}

interface IParams {
  isExport?: boolean;
  pageNumber?: number;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  text?: string;
  enabled?: boolean;
}
interface Types {
  id?: number;
  label?: string;
}
export type TCommentItem = {
  comment: string;
  createdByUserName: string;
  createdDateTime: Date | string;
  id: number;
};

export interface IParamsChange {
  id?: number;
  isExport?: boolean;
  pageNumber?: number;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  text?: string;
  search?: string;
  title?: string;
  nameChange?: string;
  textType?: string;
  stateChange?: number;
  changeTypeIds?: Types[];
  typeChange?: Types[];
  stageChange?: Types;
  changeStageIds?: Types[];
  changeStatusIds?: number[];
  changeServiceIds?: Types[];
  categoryIds?: Types;
  subcategoryIds?: Types;
  assignmentPriorityIds?: number[];
  createdDateTimeStart?: string;
  createdDateTimeEnd?: string;
  startDateTimeStart?: string;
  startDateTimeEnd?: string;
  endDateTimeStart?: string;
  endDateTimeEnd?: string;
  startDateTime?: string;
  approvalDateTimeStart?: string;
  approvalDateTimeEnd?: string;
  background?: string;
  downtimeHours?: number;
  dateEnd?: string;
  dateInitial?: string;
  createdDateTime?: string;
  assignedEngineerDateTime?: string;
  requestedEmail?: string;
  requesterEmail?: string;
  endDateTime?: string;
  cabMember?: number;
  changeStepId?: number;
  comments?: TCommentItem[];
}
export interface ReponseChangeSearch {
  assignmentPriorityId?: number;
  assignmentPriorityName?: string;
  categoryId?: number;
  categoryName?: string;
  changeServiceId?: number;
  changeServiceName?: string;
  changeStageId?: number;
  changeStageName?: string;
  changeStatusId?: number;
  changeStatusName?: string;
  changeTypeId?: number;
  changeTypeName?: string;
  assignedEngineerDateTime?: string;
  description?: string;
  endDateTime?: string;
  id?: number;
  startDateTime?: string;
  subcategoryId?: number;
  subcategoryName?: string;
  title?: string;
  hasPendingApprovals?: boolean;
  approvalId?: number;
  changeStepId?: number;
  comments?: TCommentItem[];
  createdDateTime?: Date | string;
}

export interface IParamsSearchApprovals {
  systemUserId?: number;
  approvalStatusId?: number;
  changeStepId?: number;
  approvalId?: number;
  isExport?: boolean;
  pageNumber?: number;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  text?: string;
}
export interface IChangesApprovalItem {
  changeStepId: number;
  changeId: number;
  changeName: string;
  approvalId: number;
  approvalStatusId: number;
  approverId: number;
  approverName: string;
  approverEmail: string;
  approvalStatusName: string;
  notificationDateTime: Date | string;
  approvedDateTime: Date | string;
  comment?: string;
}

export interface ItemCABRequest {
  id: number;
  name: string;
  description: string;
  members: number[];
}

export interface SearchTasksParams {
  TicketId?: number;
  problemId?: number;
  PageNumber?: number;
  OrderColumn?: string;
  Descending?: boolean;
  PageSize?: number;
  Text?: string;
  IsExport?: boolean;
}

export interface TaskResponse {
  id?: number;
  name?: string;
  description?: string;
  enabled?: boolean;
  taskStatusId?: number;
  taskStatusName?: string;
  taskTypeId?: number;
  taskTypeName?: string;
  ownerId?: number;
  ownerName?: string;
  startShceduledDate?: string;
  endScheduledDate?: string;
  progress?: number;
  startRealDate?: Date | string;
  endRealDate?: Date | string;
  estimatedDays?: number;
  estimatedHours?: number;
  estimatedMinutes?: number;
  priorityId?: number;
  priorityName?: string;
}

export interface CreationTask {
  name?: string;
  taskStatusId?: number;
  description?: string;
  taskTypeId?: number;
  startScheduledDate?: Date;
  endScheduledDate?: Date;
  endscheduledDate?: Date;
  startRealDate?: Date;
  endRealDate?: Date;
  priorityId?: number;
  ticketId?: number;
  ownerId?: number;
  cost?: number;
  groupId?: number;
  scheduleStartDate?: Date;
  estimatedDays?: number;
  estimatedHours?: number;
  estimatedMinutes?: number;
  progress?: number;
  comment?: string;
  problemId?: number;
}
export interface IChangeFlowParams {
  isBase?: boolean;
  ChangeFlowId?: number;
}

export interface IFlowOfChangeRequest {
  changeFlowId: number;
  enabled?: boolean;
  name: string;
  edges: {
    initialStageId: number;
    finalStageId: number;
    isInitialStage: boolean;
  }[];
}

export interface IItemFlowResponse {
  base: boolean;
  enabled: boolean;
  id: number;
  name: string;
}

export type TStatusesFlow = {
  id: 1;
  description: string;
  enabled: true;
  nextStageId?: number;
};

export type TStage = {
  id: number;
  description: string;
  enabled: boolean;
  statuses: TStatusesFlow[];
};

export interface IEdgeChangeFlow {
  initialStage: TStage;
  finalStage: TStage;
  isInitialStage: boolean;
  enabled: boolean;
}
export interface IFlowDiagramResponse {
  createdDateTime: Date | string;
  edges: IEdgeChangeFlow[];
  historical?: boolean;
  id: number;
  name: string;
  enabled: boolean;
  base: boolean;
}

export interface IStages {
  stage: TStage[];
}
export interface IItemFlowById {
  createdDateTime: Date | string;
  stages: IStages;
  historical?: boolean;
  id: number;
  name: string;
  enabled: boolean;
  base: boolean;
}

export interface EditTaskResponse {
  id?: number;
  name?: string;
  taskStatusId?: number;
  taskStatusName?: string;
  description?: string;
  taskTypeId?: number;
  taskTipeName?: string;
  startScheduledDate?: Date;
  endScheduledDate?: Date;
  startRealDate?: Date;
  endRealDate?: Date;
  priorityId?: number;
  priorityName?: string;
  ticketId?: number;
  ownerId?: number;
  ownerName?: string;
  cost?: number;
  estimatedDays?: number;
  estimatedHours?: number;
  estimatedMinutes?: number;
  progress?: number;
  comments?: Comment[];
}

export interface Comment {
  id?: number;
  comment?: string;
  initialStatusName?: string;
  finalStatusName?: string;
  createdByUserId?: number;
  createdByUserName?: string;
  createdDateTime?: Date;
}

export interface EditTaskRequest {
  id?: number;
  name?: string;
  taskStatusId?: number;
  description?: string;
  taskTypeId?: number;
  startScheduledDate?: Date;
  endScheduledDate?: Date;
  startRealDate?: Date;
  endRealDate?: Date;
  priorityId?: number;
  ownerId?: number;
  cost?: number;
  estimatedDays?: number;
  estimatedHours?: number;
  estimatedMinutes?: number;
  progress?: number;
  comment?: string;
  enabled?: boolean;
}

export interface IModalValidationResquest {
  changeId: number;
  systemUserId?: number;
}

export interface IModalValidationResponse {
  showModal: boolean;
  approvalId: number;
  changeId: number;
  changeName: string;
}

export interface SearchSolutionsRequest {
  pageNumber?: number;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  text?: string;
  isExport?: boolean;
  enabled?: boolean;
  solutionStatusIds?: number[];
  toReview?: boolean;
  withoutReviewDate?: boolean;
  updatedDateTime?: Date;
  createdDateTime?: Date;
  createdUserId?: number;
  expirationDate?: Date;
  reviewDate?: Date;
  solutionId?: number;
  keywords?: string;
  ownerUserId?: number;
  topicId?: number;
  title?: string;
  updatedUserId?: number;
}

export interface SearchSolutionsResponse {
  id?: number;
  solutionId?: number;
  title?: string;
  topicId?: number;
  topicName?: string;
  keywords?: string;
  solutionStatusId?: number;
  solutionStatusName?: string;
  viewsCount?: number;
  createdUserId?: number;
  createdDateTime?: Date;
  updatedUserId?: number;
  updatedDateTime?: Date;
  reviewDate?: Date;
  expirationDate?: Date;
  ownerUserIds?: number[];
  isPrimarySolution: boolean;
}

export interface GetAllSolutionStatesResponse {
  id?: number;
  name?: string;
  enabled?: boolean;
  createdUserId?: number;
  createdDateTime?: Date;
  updatedUserId?: number;
  updatedDateTime?: string;
}

export interface ICommentChange {
  changeId: number;
  comment: string;
}

export interface IProductChange {
  changeId: number;
  productIds: number[];
}

export interface IChangeResponse {
  id: number;
  clientId: number;
  clientName: string;
  locationId: number;
  locationName: string;
  requestedEmail: string;
  requestedByUserId: number;
  requestedByUserName: string;
  changeTypeId: number;
  changeTypeName: string;
  changeServiceId: number;
  changeServiceName: string;
  categoryId: number;
  categoryName: string;
  subcategoryId: number;
  subcategoryName: string;
  assignmentPriorityId: number;
  assignmentPriorityName: string;
  engineerId: number;
  engineerName: string;
  assignedEngineerDateTime: null;
  ownerSystemUserId: number;
  ownerSystemUserName: string;
  isServiceAffected: true;
  title: string;
  description: string;
  background: string;
  downtimeHours: number;
  startDateTime: Date | string;
  endDateTime: Date | string;
  changeFlowId: number;
  changeFlowName: string;
  changeStageId: number;
  changeStageName: string;
  changeStatusId: number;
  changeStatusName: string;
  changeStepId: number;
  projectName?: string;
  products: {
    productId: number;
    serialNumber: string;
  }[];
  comments: TCommentItem[];
  approvals: {
    id: number;
    approvalStatusName: string;
    changeStageName: string;
    systemUserName: string;
    systemUserId: number;
    approvalDateTime: Date | string;
    comment: string;
    createdByUserName: string;
    createdByUserId: number;
    createdDateTime: Date | string;
    approvalStatusId: number;
    systemUserAdvisoryBoards: {
      id: number;
      name: string;
    }[];
  }[];
  steps: {
    id: number;
    changeStageId: number;
    changeStageName: string;
    requireApproval: number;
  }[];
  createdDateTime?: Date | string;
}

export interface IProblemSearchRequest extends IParams {
  textType?: number;
  title?: string;
  problemStatusIds?: number[];
  categoryIds?: number[];
  subcategoryIds?: number[];
  impactIds?: number[];
  urgencyIds?: number[];
  priorityIds?: number[];
  engineerIds?: number[];
  requesterIds?: number[];
  createdDateTimeStart?: Date | string;
  createdDateTimeEnd?: Date | string;
  startDateTimeStart?: Date | string;
  startDateTimeEnd?: Date | string;
  endDateTimeStart?: Date | string;
  endDateTimeEnd?: Date | string;
  myProblems?: boolean;
}

export interface IProblemCategory {
  id: number;
  name: string;
  createdUserId: number;
  createdDateTime: Date | string;
  updatedUserId: null;
  updatedDateTime: null;
  enabled: boolean;
  rowVersion: string;
  description: string;
  parentCategoryId: number;
  createdUser: null;
  parentCategory: null;
  updatedUser: null;
  changes: [];
  inverseParentCategory: [];
  tickets: [];
  problemCategories: [];
  problemSubCategories: [];
}
export interface IProblemSearchResponse {
  id: number;
  title: string;
  problemStatusId: number;
  problemStatusName: string;
  createdDateTime: Date | string;
  createdUserId: number;
  categoryId: number;
  categoryName: string;
  subcategoryId: IProblemCategory;
  subcategoryName: string;
  priorityId: number;
  priorityName: string;
  urgencyId: number;
  urgencyName: string;
  impactId: number;
  impactName: 'Bajo';
  engineerId: number;
  engineerName: string;
  requesterId: number;
  requesterName: string;
  description: string;
  endDateTime: Date | string;
  knownIssue: null;
  knownIssueDetails: [];
}

export interface ICreateProblem {
  id?: number;
  title: string;
  description: string;
  categoryId: number;
  subCategoryId: number;
  impactId: number;
  urgencyId: number;
  priorityId: number;
  groupId: number;
  statusId: number;
  requestedByUserId: number;
  engineerId: number;
  endDateTime: Dayjs | string;
  productIds: number[];
  products: {
    productId: number;
    serialNumber: string;
  }[];
}

interface Subcategory {
  id: number;
  name: string;
  createdUserId: number;
  createdDateTime: string;
  updatedUserId: number | null;
  updatedDateTime: string | null;
  enabled: boolean;
  rowVersion: string;
  description: string;
  parentCategoryId: number;
  tickets?: unknown[];
}

export interface IKnownIssueDetails {
  id: number;
  updataKnownIssue: Date | string;
  commentKnownIssue: string;
  updatedUserId: number;
  updatedUserName: string;
}

export interface IProblemAnalysis {
  sectionId: number;
  sectionName: string;
  displayOrder: number;
  note: INote;
}

export interface IProblemDetail {
  id: number;
  requestedByUserId: number;
  requestedByUserName: string;
  categoryId: number;
  categoryName: string;
  subcategoryId: Subcategory;
  subcategoryName: string;
  assignedEngineerId: number;
  assignedEngineerName: string;
  assignedEngineerDateTime: string;
  title: string;
  description: string;
  endDateTime: string;
  problemStatusId: number | null;
  problemStatusName: string | null;
  priorityId: number | null;
  priorityName: string | null;
  urgencyId: number | null;
  urgencyName: string | null;
  impactId: number | null;
  impactName: string | null;
  products: {
    productId: number;
    serialNumber: string;
  }[];
  tickets?: unknown[];
  knownIssue: boolean | null;
  knownIssueDetails: IKnownIssueDetails[];
  createdDateTime: string;
  groupId: number | null;
  groupName: string | null;
  problemAnalysis?: IProblemAnalysis[];
  notes?: INote[];
}

export interface ISetProblemKnownIssue {
  isKnownIssue: boolean;
  problemId: number;
  comment: string;
}

export interface IUpdateProblemStatus {
  problemId: number;
  finalStatusId: number;
}

export interface IAssignProblem {
  problemId: number;
  groupId: number;
  engineerUserId: number;
}

export interface IUpdateProblemPriority {
  problemId: number;
  priorityId: number;
}

export interface NewSolutionRequest {
  title?: string;
  content?: string;
  solutionTopicId?: number;
  ownerSystemUserIds?: number[];
  reviewDate?: Date;
  expirationDate?: Date;
  keywords?: string;
  internalComments?: string;
}

export interface SolutionByIDResponse {
  id?: number;
  title?: string;
  content?: string;
  topicId?: number;
  topicName?: string;
  solutionStatusId?: number;
  solutionStatusName?: string;
  ownerSystemUserIds?: number;
  ownerSystemUsersData?: {
    systemUserId: number;
    systemUserFullName: string;
  }[];
  reviewDate?: Date;
  expirationDate?: Date;
  viewsCount?: number;
  createdByUserName?: string;
  createdDateTime?: Date;
  updatedByUserName?: null;
  updatedDateTime?: null;
  requestsCount?: number;
  problemsCount?: number;
  solutionsCount?: number;
  keywords?: string;
  internalComments?: string;
}

export interface SolutionUpdateRequest {
  id?: number;
  title?: string;
  content?: string;
  solutionTopicId?: number;
  ownerSystemUserIds?: number[];
  reviewDate?: Date;
  expirationDate?: Date;
  keywords?: string;
  internalComments?: string;
}

export interface IRelatedProblem {
  solutionId: number;
  problemIds: number[];
  isPrimarySolution: boolean;
}

export interface IRelatedTicketProblem {
  ticketIds: number[];
  problemId: number;
}

export interface IAnalysisSection {
  id: number;
  name: string;
  description: string;
  displayOrder: number;
}

export interface IFileNote {
  fileId: number;
  fileName: string;
  fileDescription: string;
  blobStorageUrlPath: string;
}

export interface INote {
  noteId: number;
  comment: string;
  createdUserId: number;
  createdUserName: string;
  createdDateTime: Date | string;
  updatedDateTime: Date | string;
  updatedUserName: string;
  analysisSectionId: number;
  analysisSectionName: string;
  files?: IFileNote[];
}

export interface IAnalysisSectionNotes {
  problemId: number;
  notes: INote[];
}

export interface ICreateProblemNote {
  comment: string;
  problemId: number;
  analysisSectionId?: number;
}

export interface IUpdateProblemNote {
  comment: string;
  noteId: number;
}

export interface ITaskByProblemId {
  totalTask: number;
  completeTask: number;
}

export default {
  instance,
  changeAdvisoryBoard: {
    /**
     * Obtiene todos los comités activos.
     *
     * @tags ChangeAdvisoryBoard
     * @name getAll
     * @request GET: /api/v1/ChangeAdvisoryBoard
     * @secure
     */
    getAll: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ItemCABResponse[]>>({
        url: `/ChangeAdvisoryBoard`,
        method: 'GET',
        ...config
      }),
    /**
     * Búsqueda de comités
     *
     * @tags SearchChangeAdvisoryBoard
     * @name SearchChangeAdvisoryBoard
     * @request POST: /api/v1/ChangeAdvisoryBoard/SearchChangeAdvisoryBoard
     * @secure
     */
    searchChangeAdvisoryBoard: (
      params: IParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<ItemCABResponse>>>({
        url: `/ChangeAdvisoryBoard/SearchChangeAdvisoryBoard`,
        method: 'POST',
        params,
        ...config
      }),
    /**
     * Crea un comité.
     *
     * @tags SearchChangeAdvisoryBoard
     * @name SearchChangeAdvisoryBoard
     * @request POST: /api/v1/ChangeAdvisoryBoard
     * @secure
     */
    create: (data: ItemCABRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ItemCABResponse>>({
        url: `/ChangeAdvisoryBoard`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Actualiza un comité.
     *
     * @tags SearchChangeAdvisoryBoard
     * @name SearchChangeAdvisoryBoard
     * @request PUT: /api/v1/ChangeAdvisoryBoard
     * @secure
     */
    update: (data: ItemCABRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ItemCABResponse>>({
        url: `/ChangeAdvisoryBoard`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Obtiene un Comité por su ID.
     *
     * @tags SearchChangeAdvisoryBoard
     * @name SearchChangeAdvisoryBoard
     * @request GET: /api/v1/ChangeAdvisoryBoard/{id}
     * @secure
     */
    getById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ItemCABResponse>>({
        url: `/ChangeAdvisoryBoard/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Elimina un comité por su ID.
     *
     * @tags SearchChangeAdvisoryBoard
     * @name SearchChangeAdvisoryBoard
     * @request DELETE: /api/v1/ChangeAdvisoryBoard/{id}
     * @secure
     */
    delete: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ItemCABResponse>>({
        url: `/ChangeAdvisoryBoard/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  approvals: {
    /**
     * Search approvals
     *
     * @tags Approvals
     * @name searchApprovals
     * @request GET: /api/v1/Approvals/SearchApprovals
     * @secure
     */
    SearchApprovals: (
      params: IParamsSearchApprovals,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<IChangesApprovalItem>>
      >({
        url: `/Approvals/SearchApprovals`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Get approvals by change step id
     *
     * @tags Approvals
     * @name GetApprovalsByChangeStepId
     * @request GET: /api/v1/Approvals/GetApprovalsByChangeStepId/{id}
     * @secure
     */
    GetApprovalsByChangeStepId: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<[]>>({
        url: `/Approvals/GetApprovalsByChangeStepId/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Approve or reject a change
     *
     * @tags Approvals
     * @name ApproveChange
     * @request POST:api/v1/Approvals/ApproveChange
     * @secure
     */
    ApproveChange: (
      data: IApproveChangeRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<[]>>({
        url: `/Approvals/ApproveChange`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Send approval notification with approval ids and change step id
     *
     * @tags Approvals
     * @name SendApprovalNotification
     * @request POST: /api/v1/Approvals/SendApprovalNotification
     * @secure
     */
    SendApprovalNotification: (
      data: ISendApprovalNotification,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<[]>>({
        url: `/Approvals/SendApprovalNotification`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Add approval members to a change step
     *
     * @tags Approvals
     * @name AddApprovalMembers
     * @request POST: /api/v1/Approvals/AddApprovalMembers
     * @secure
     */
    AddApprovalMembers: (
      data: IAddApprovalMembers,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<[]>>({
        url: `/Approvals/AddApprovalMembers`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Remove an approval member from a change step
     *
     * @tags Approvals
     * @name RemoveApprovalMembers
     * @request DELETE: /api/v1/Approvals/RemoveApprovalMembers
     * @secure
     */
    RemoveApprovalMembers: (
      data: IAddApprovalMembers,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<[]>>({
        url: `/Approvals/RemoveApprovalMembers`,
        method: 'DELETE',
        data,
        ...config
      }),
    /**
     * Obtiene el estado de aprobación para mostrar el modal
     *
     * @tags Approvals
     * @name ModalValidation
     * @request GET: /api/v1/Approvals/ModalValidation
     * @secure
     */
    ModalValidation: (
      params: IModalValidationResquest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<IModalValidationResponse>>({
        url: `/Approvals/ModalValidation`,
        method: 'GET',
        params,
        ...config
      })
  },
  ChangeFlow: {
    /**
     * Búsqueda general de flujos
     *
     * @tags ChangeFlow
     * @name search
     * @request POST: /api/v1/ChangeFlow/search
     * @secure
     */
    search: (data: IParams, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<IItemFlowResponse>>
      >({
        url: `/ChangeFlow/search`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Obtiene un flujo por su Id
     *
     * @tags ChangeFlow
     * @name GetChangeFlow
     * @request GET: /api/v1/ChangeFlow
     * @secure
     */
    getChangeFlow: (
      params: IChangeFlowParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<IFlowDiagramResponse>>({
        url: `/ChangeFlow`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Crea un nuevo flujo de cambio
     *
     * @tags ChangeFlow
     * @name create
     * @request POST:/api/v1/ChangeFlow
     * @secure
     */
    create: (data: IFlowOfChangeRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ItemCABResponse>>({
        url: `/ChangeFlow`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Actualiza un flujo de cambio.
     *
     * @tags ChangeFlow
     * @name update
     * @request PUT: /api/v1/ChangeFlow
     * @secure
     */
    update: (data: IFlowOfChangeRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ItemCABResponse>>({
        url: `/ChangeFlow`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Actualiza un flujo de cambio.
     *
     * @tags ChangeFlow
     * @name delete
     * @request delete: /api/v1/ChangeFlow/{id}
     * @secure
     */
    delete: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ItemCABResponse>>({
        url: `/ChangeFlow/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Obtiene las etapas de un flujo por su Id o el base si no se envía
     *
     * @tags ChangeFlow
     * @name getStagesOfChangeFlow
     * @request GET:/api/v1/ChangeFlow/Stages
     * @secure
     */
    getStagesOfChangeFlow: (
      params: { id?: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<IItemFlowById>>({
        url: `/ChangeFlow/stages`,
        method: 'GET',
        params,
        ...config
      })
  },
  tasks: {
    /**
     * Get Task by Ticket Id
     *
     * @tags TASKS
     * @name generalSearchTasks
     * @request GET:/api/v1/Task/SearchTasksByTicketId
     * @secure
     */
    generalSearchTasks: (
      params: SearchTasksParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<TaskResponse>>>({
        url: `/Task/SearchTasksByTicketId`,
        method: 'GET',
        params,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'repeat' }),
        ...config
      }),
    /**
     * Create new Task
     *
     * @tags TASKS
     * @name createNewTask
     * @request POST:/api/v1/Task
     * @secure
     */
    createNewTask: (data: CreationTask, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Task`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Get Task by Id
     *
     * @tags TASKS
     * @name getTaskById
     * @request GET:/api/v1/Task/{id}
     * @secure
     */
    getTaskById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<EditTaskResponse>>({
        url: `/Task/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Delete Task by Id
     *
     * @tags TASKS
     * @name deleteTaskById
     * @request DELETE:/api/v1/Task/{id}
     * @secure
     */
    deleteTaskById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Task?taskId=${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Update Task
     *
     * @tags TASKS
     * @name updateTask
     * @request PUT:/api/v1/Task/{id}
     * @secure
     */
    updateTask: (data: EditTaskRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<EditTaskResponse>>({
        url: `/Task`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Realiza una búsqueda tareas de un problema
     *
     * @tags Task
     * @name SearchTasksByProblemId
     * @request GET:/api/v1/Task/SearchTasksByProblemId
     * @secure
     */
    SearchTasksByProblemId: (
      params: SearchTasksParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<TaskResponse>>>({
        url: `/Task/SearchTasksByProblemId`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Consulta la cantidad de tareas completas de un problema
     *
     * @tags Task
     * @name GetTaskCompleteByProblemId
     * @request GET:/api/v1/Task/GetTaskCompleteByProblem/{id}
     * @secure
     */
    GetTaskCompletedByProblemId: (
      id: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ITaskByProblemId>>({
        url: `/Task/GetTaskCompleteByProblem/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Crea una tarea para un Problema
     *
     * @tags Task
     * @name CreateTaskProblem
     * @request POST:/api/v1/Task/CreateTaskProblem
     * @secure
     */
    CreateTaskProblem: (data: CreationTask, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Task/CreateTaskProblem`,
        method: 'POST',
        data,
        ...config
      })
  },
  changes: {
    /**
     * Get Task by Ticket Id
     *
     * @tags TASKS
     * @name generalSearchTasks
     * @request GET:/api/v1/Task/SearchTasksByTicketId
     * @secure
     */
    getByChange: (changeId: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<IChangeResponse>>({
        url: `/Changes/${changeId}`,
        method: 'GET',
        ...config
      }),
    /**
     * Búsqueda de cambios
     *
     * @tags Changes
     * @name searchChange
     * @request POST: /api/v1/Changes/search
     * @secure
     */
    searchChange: (data: IParamsChange, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<IChangeResponse>>>({
        url: `/Changes/search`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Crea un cambio.
     *
     * @tags CreateNewChange
     * @name CreateNewChange
     * @request POST: /api/v1/Changes
     * @secure
     */
    create: (data: SaveTicketRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Changes`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Editar un cambio.
     *
     * @tags updateChange
     * @name updateChange
     * @request PUT: /api/v1/Changes
     * @secure
     */
    update: (data: IParamsChange, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Changes`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Elimina un comité por su ID.
     *
     * @tags DeleteChange
     * @name DeleteChange
     * @request DELETE: /api/v1/ChangeAdvisoryBoard/{id}
     * @secure
     */
    delete: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ItemCABResponse>>({
        url: `/Changes/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Agrega un comentario al cambio actual
     *
     * @tags Changes
     * @name addComments
     * @request POST: /api/v1/Changes/{id}/comments
     * @secure
     */
    addComments: (data: ICommentChange, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Changes/${data?.changeId}/comments`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Agrega uno o mas productos a un cambio
     *
     * @tags Changes
     * @name addProducts
     * @request POST: /api/v1/Changes/{id}/products
     * @secure
     */
    addProducts: (data: IProductChange, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Changes/${data?.changeId}/products`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Elimina un producto del cambio
     *
     * @tags Changes
     * @name deleteProduct
     * @request POST: /api/v1/Changes/{id}/products
     * @secure
     */
    deleteProduct: (data: IProductChange, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Changes/${data?.changeId}/products`,
        method: 'DELETE',
        data,
        ...config
      })
  },
  solutions: {
    /**
     * GeneralSearch Solutions
     *
     * @tags SOLUTIONS
     * @name searchSolutions
     * @request POST:/api/v1/Solution/search
     * @secure
     */
    searchSolutions: (
      data: SearchSolutionsRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<SearchSolutionsResponse>>
      >({
        url: `/Solution/search`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Get all solutions Status
     *
     * @tags SOLUTIONS
     * @name getAllSolutionsStatus
     * @request GET:/api/v1/Solution/GetAllSolutionStates
     * @secure
     */
    getAllSolutionsStatus: (config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<GetAllSolutionStatesResponse[]>
      >({
        url: `/Solution/GetAllSolutionStates`,
        method: 'GET',
        ...config
      }),
    /**
     * Create new Solution
     *
     * @tags SOLUTIONS
     * @name createNewSolution
     * @request POST:/api/v1/Solution
     * @secure
     */
    createNewSolution: (
      data: NewSolutionRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{
          id?: number;
          createdDateTimeUTC?: Date;
        }>
      >({
        url: `/Solution`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * update Solution
     *
     * @tags SOLUTIONS
     * @name updateSolution
     * @request PUT:/api/v1/Solution
     * @secure
     */
    updateSolution: (
      data: SolutionUpdateRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{
          id?: number;
          createdDateTimeUTC?: Date;
        }>
      >({
        url: `/Solution`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Get Solution By Id
     *
     * @tags SOLUTIONS
     * @name getSolutionById
     * @request GET:/api/v1/Solution/1
     * @secure
     */
    getSolutionById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SolutionByIDResponse>>({
        url: `/Solution/${id}`,
        method: 'GET',
        ...config
      }),

    /**
     * Asociar una solución a problema/s
     *
     * @tags SOLUTIONS
     * @name RelatedProblem
     * @request   POST: /api/v1/Solution/RelatedProblem
     * @secure
     */
    RelatedProblem: (data: IRelatedProblem, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<{
          id?: number;
          createdDateTimeUTC?: Date;
        }>
      >({
        url: `/Solution/RelatedProblem`,
        method: 'POST',
        data,
        ...config
      })
  },
  problems: {
    /**
     * GeneralSearch Problems
     *
     * @tags Problems
     * @name search
     * @request POST:/api/v1/Problems/search
     * @secure
     */
    search: (data: IProblemSearchRequest, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<IProblemSearchResponse>>
      >({
        url: `/Problems/search`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Crea un nuevo Problema
     *
     * @tags Problems
     * @name create
     * @request POST:/api/v1/Problems
     * @secure
     */
    create: (data: ICreateProblem, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<{ id: number; title: string }>
      >({
        url: `/Problems`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Actualiza un Problema
     *
     * @tags Problems
     * @name update
     * @request POST:/api/v1/Problems
     * @secure
     */
    update: (data: ICreateProblem, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<{ id: number }>>({
        url: `/Problems`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Elimina un Problema
     *
     * @tags Problems
     * @name delete
     * @request POST:/api/v1/Problems/{id}
     * @secure
     */
    delete: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<{ id: number }>>({
        url: `/Problems/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Obtiene un Problema por id
     *
     * @tags Problems
     * @name getById
     * @request POST:/api/v1/Problems/{id}
     * @secure
     */
    getById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<IProblemDetail>>({
        url: `/Problems/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * Crea un nuevo Problema
     *
     * @tags Problems
     * @name SetProblemKnownIssue
     * @request POST:/api/v1/Problems/SetProblemKnownIssue
     * @secure
     */
    SetProblemKnownIssue: (
      data: ISetProblemKnownIssue,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{ id: number; title: string }>
      >({
        url: `/Problems/SetProblemKnownIssue`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Actualiza el estatus de un problema
     *
     * @tags Problems
     * @name UpdateProblemStatus
     * @request POST:/api/v1/Problems/UpdateProblemStatus
     * @secure
     */
    UpdateProblemStatus: (
      data: IUpdateProblemStatus,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{ id: number; title: string }>
      >({
        url: `/Problems/UpdateProblemStatus`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Asignar un problema
     *
     * @tags Problems
     * @name AssignProblem
     * @request POST:/api/v1/Problems/AssignProblem
     * @secure
     */
    AssignProblem: (data: IAssignProblem, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<{ id: number; title: string }>
      >({
        url: `/Problems/AssignProblem`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Asignar una prioridad a un cambio
     *
     * @tags Problems
     * @name UpdateProblemPriority
     * @request POST:/api/v1/Problems/UpdateProblemPriority
     * @secure
     */
    UpdateProblemPriority: (
      data: IUpdateProblemPriority,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{ id: number; title: string }>
      >({
        url: `/Problems/UpdateProblemPriority`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Agrega uno o varios productos al Problema
     *
     * @tags Problems
     * @name addProducts
     * @request POST:/api/v1/Problems/Problems/{id}/products
     * @secure
     */
    addProducts: (
      problemId: number,
      data: { productIds: number[] },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{ id: number; title: string }>
      >({
        url: `/Problems/${problemId}/products`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Elimina uno o varios productos del Problema
     *
     * @tags Problems
     * @name deleteProducts
     * @request POST:/api/v1/Problems/Problems/{id}/products
     * @secure
     */
    deleteProducts: (
      problemId: number,
      data: { productIds: number[] },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{ id: number; title: string }>
      >({
        url: `/Problems/${problemId}/products`,
        method: 'DELETE',
        data,
        ...config
      }),
    /**
     * Obtiene las Soluciones asociadas a un Problema
     *
     * @tags Problems
     * @name getSolutionsRelated
     * @request GET: /api/v1/Problems/{id}/solutions
     * @secure
     */
    getRelatedSolutions: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<SearchSolutionsResponse[]>>({
        url: `/Problems/${id}/solutions`,
        method: 'GET',
        ...config
      }),
    /**
     * Obtiene las solicitudes vinculadas a un problema
     *
     * @tags Problems
     * @name getRelatedRequests
     * @request GET:/api/v1/Problems/{id}/RelatedTickets
     * @secure
     */
    getRelatedRequests: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ITicketProblemResponse[]>>({
        url: `/Problems/${id}/RelatedTickets`,
        method: 'GET',
        ...config
      }),
    /**
     * Establece un ticket de tipo "Solicitud" como relacionado al problema
     *
     * @tags Problems
     * @name SetRelatedTicket
     * @request   POST:/api/v1/Problems/SetRelatedTicket
     * @secure
     */
    SetRelatedTicket: (
      data: IRelatedTicketProblem,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{
          id?: number;
        }>
      >({
        url: `/Problems/SetRelatedTicket`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Elimina la relación entre un ticket y un problema
     *
     * @tags Problems
     * @name RemoveRelatedTicket
     * @request DELETE:/api/v1/Problems/RemoveRelatedTicket
     * @secure
     */
    RemoveRelatedTicket: (
      data: IRelatedTicketProblem,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{
          id?: number;
        }>
      >({
        url: `/Problems/RemoveRelatedTicket`,
        method: 'DELETE',
        data,
        ...config
      }),
    /**
     * Obtiene las secciones de análisis de problemas
     *
     * @tags Problems
     * @name getAnalysisSections
     * @request GET:/api/v1/Problems/AnalysisSections
     * @secure
     */
    getAnalysisSections: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<IAnalysisSection[]>>({
        url: `/Problems/AnalysisSections`,
        method: 'GET',
        ...config
      }),
    /**
     * Obtiene las notas asociadas a un Problema
     *
     * @tags Problems
     * @name getNotes
     * @request GET: /api/v1/Problems/{id}/note
     * @secure
     */
    getNotes: (
      problemId: number,
      params: { analysisSectionId?: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<IAnalysisSectionNotes[]>>({
        url: `/Problems/${problemId}/note`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     *  Guardar una Nota de un Problema
     *
     * @tags Problems
     * @name CreateProblemNote
     * @request   POST: /api/v1/Problems/CreateProblemNote
     * @secure
     */
    CreateProblemNote: (
      data: ICreateProblemNote,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{
          id?: number;
        }>
      >({
        url: `/Problems/CreateProblemNote`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     *  Actualiza una Nota de un Problema
     *
     * @tags Problems
     * @name UpdateNote
     * @request PUT: /api/v1/Problems/UpdateNote
     * @secure
     */
    UpdateNote: (data: IUpdateProblemNote, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<{
          noteId?: number;
        }>
      >({
        url: `/Problems/UpdateNote`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * Eliminar una Nota de un problema
     *
     * @tags Problems
     * @name DeleteProblemNote
     * @request DELETE: /api/v1/Problems/DeleteProblemNote
     * @secure
     */
    DeleteProblemNote: (
      params: { noteId: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{
          id?: number;
        }>
      >({
        url: `/Problems/DeleteProblemNote`,
        method: 'DELETE',
        params,
        ...config
      })
  },
  ticketStatus: {
    /**
     * Obtiene listado de los estados de un Ticket
     *
     * @tags TicketStatus
     * @name getTicketStatus
     * @request GET:/api/v1/TicketStatus
     * @secure
     */
    getTicketStatus: (config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<{ id: number; name: string }[]>
      >({
        url: `/TicketStatus`,
        method: 'GET',
        ...config
      })
  }
};
